import React from "react";
import className from "classnames/bind";
import styles from "../OrderInfoPage.module.scss";
import useTranslations from "../../../hooks/useTranslations";

const cx = className.bind(styles);

const ShippingDetailsForm = ({
  formData,
  handleInputChange,
  shippingLocation,
  provinces,
  handleShippingProvinceChange,
  handleShippingDistrictChange,
  handleShippingWardChange,
}) => {
  const translations = useTranslations();

  return (
    <div className={cx("section")}>
      <div className={cx("section-header")}>
        <h3>
          {translations?.Checkout?.shipping_details || "Shipping Details"}
        </h3>
      </div>
      <div className={cx("form-group")}>
        <input
          type="text"
          name="shippingAddress"
          placeholder="Địa chỉ cụ thể (số nhà, tên đường)"
          value={formData.shippingAddress}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className={cx("form-row")}>
        <select
          name="shippingProvince"
          value={shippingLocation.selectedProvince?.id || ""}
          onChange={handleShippingProvinceChange}
          required
          className={cx("form-select")}
        >
          <option value="">Chọn Tỉnh/Thành phố</option>
          {provinces &&
            provinces.map((province) => (
              <option key={province.id} value={province.id}>
                {province.name}
              </option>
            ))}
        </select>

        <select
          name="shippingDistrict"
          value={shippingLocation.selectedDistrict?.id || ""}
          onChange={handleShippingDistrictChange}
          disabled={!shippingLocation.selectedProvince}
          required
          className={cx("form-select")}
        >
          <option value="">Chọn Quận/Huyện</option>
          {shippingLocation.districts &&
            shippingLocation.districts.map((district) => (
              <option key={district.id} value={district.id}>
                {district.name}
              </option>
            ))}
        </select>
        <select
          name="shippingWard"
          value={shippingLocation.selectedWard?.id || ""}
          onChange={handleShippingWardChange}
          disabled={!shippingLocation.selectedDistrict}
          required
          className={cx("form-select")}
        >
          <option value="">Chọn Phường/Xã</option>
          {shippingLocation.wards &&
            shippingLocation.wards.map((ward) => (
              <option key={ward.id} value={ward.id}>
                {ward.name}
              </option>
            ))}
        </select>
      </div>
      <div className={cx("form-row")}>
        <input
          type="text"
          name="shippingZipCode"
          placeholder="ZIP Code"
          value={formData.shippingZipCode}
          onChange={handleInputChange}
          required
        />
        <input
          type="text"
          name="shippingState"
          placeholder="State"
          value={formData.shippingState}
          onChange={handleInputChange}
          required
        />
        <input
          type="text"
          name="shippingCountry"
          placeholder="Country"
          value={formData.shippingCountry}
          onChange={handleInputChange}
          required
        />
      </div>
    </div>
  );
};

export default ShippingDetailsForm;
